<mat-dialog-content class="mat-typography">
    <h2>
        {{ activiteEau.id ? 'Modification' : 'Ajout' }} d'une activité d'eau
    </h2>
    <form
        class="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full px-8"
        [formGroup]="form"
        (ngSubmit)="onFormSubmit()"
    >
        <mat-form-field>
            <mat-label>Plan</mat-label>
            <mat-select matSelect formControlName="etage_id">
                <mat-option *ngFor="let etage of formattedEtages" [value]="etage.id">
                    {{etage.nom_niveau}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Pièce</mat-label>
            <mat-select matSelect formControlName="piece_id" [disabled]="form.value.etage_id === 0">
                <mat-option *ngFor="let piece of pieces" [value]="piece.id">
                    {{piece.nom_piece}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Date de visite</mat-label>
            <input type="date" matInput formControlName="visit_date">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Humidité Relative</mat-label>
            <input type="text" matInput formControlName="humidity">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Température</mat-label>
            <input type="text" matInput formControlName="temperature">
        </mat-form-field>

        <mat-form-field>
            <mat-label>GPL</mat-label>
            <input type="text" matInput formControlName="gpl">
        </mat-form-field>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
